import apiClient from '@/services/axios'

export async function del(name) {
  var response = await apiClient.delete(process.env.VUE_APP_CRM_API_BASE_URL + '/GuestSegmentation/labels/?name=' + name)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete label.')
}